import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 bg-background-100 rounded-full flex items-center justify-center">
          <i className="ri-ghost-line text-3xl text-foreground-400"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-800 mb-2">页面未找到</h2>
        <p className="text-sm text-foreground-500 mb-8">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}